import axios from "axios";
import { useEffect, useState } from "react";
import { Authentication } from "../../utils/authenticationUtilityServices";
import { imsLoader } from "../../assets";
import PubMedLogsTable from "../../components/PubMedSearch/PubMedLogsTable";
import YearPicker from "../Pages/YearPicker";

const PubMedLogs = () => {

    const [files, setFiles] = useState([]);
    const [serachFile, setSearchFile] = useState('');
    const [dir, setDir] = useState('');
    const [loader, setLoader] = useState(false);
    const [fileLogs, setFileLogs] = useState([]);
    const [index, setIndex] = useState();
    const [size, setSize] = useState();
    const [toYear, setToYear] = useState('2025');
    const [fromYear, setFromYear] = useState('2023');
    useEffect(() => {
        fetchFiles();
    }, [])

    const fetchFiles = async () => {
        const _headers = {}
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get('https://predev-ims.jnj.com/api/pubmed/viewlogs/?dir=logs', {
            headers: _headers
        }).then((res) => {
            let response = res.data;
            setFiles(response.files);
            setDir(response.directory);
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleFileClick = async (selectedFile , size) => {
        setLoader(true)
        let data1 = {
            "from_": 0,
            "size": size,
            "filters": {
                //"search" : "a980a48feb714048801a9af8100d3c60"
                // "correlation_id" : "4ab7984084d9453589975f77b95f063f",
                // "fromDate" : "2025-09-0"
                // "toDate" : "2025-09-07"
            },
            //   "file_paths": ["logs/CPC-SSidd-VLTTT.log","logs/CPC-SSidd-VLTTT.log.2025-09-06"]
            // "file_paths" : ["logs/CPC-SSidd-VLTTT.log"]
            "file_paths": [`${dir}/${selectedFile}`]//["logs/CPC-SSidd-VLTTT.log"]
        }
        const _headers = {
            "Content-Type": "application/json",
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post('https://predev-ims.jnj.com/api/pubmed/viewlogs/files', data1, {
            headers: _headers
        }).then((res) => {
            let response = res.data;
            setFileLogs(response.logs);
            console.log(response.logs);
            setLoader(false);
        })
    }
    const displayFiles = (files) => {
        if (files.length > 0) {
            return (
                files.map((item, indi) => {
                    return (
                        <li key={indi} className={(indi === index) ? 'pubMed-log-li-active' : ''} onClick={() => { handleFileClick(item.filename ,size); setIndex(indi) }}><span>{item.filename}</span><span>{item.size}</span></li>
                    )
                })
            )
        }
    }
    const handleToYear = (year) =>{
        setToYear(year)
    }
    const handleFromYear = (year) => {
        setFromYear(year)
    }
    const handleSizeChange = (e) =>{
        setSize(e.target.value);
        if(index && index > -1){
        handleFileClick(files[index].filename , e.target.value)
        } 
    }
    console.log(files)
    return (<>
        {(loader) ? <><img src={imsLoader} alt="Loading" /></> : <div className="pub-med-log-main-container">
            <div className="pubmed-log-box" style={{ height: `${window.innerHeight}px` }}>
                <div className="pubmed-log-left-container">
                    <div style={{ fontWeight: '700', fontSize: '24px', background: '#f0f8ff', padding: '7px 8px', marginTop: '2px' }}>Files</div>
                    {files.length > 0 ?
                        <ul>
                            {displayFiles(files)}
                        </ul> : <></>}
                </div>
                <div className="pubmed-log-right-container">
                    <div className="pubmed-log-searchBar">
                        <div>
                            <span className="">
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="magnifying-glass" className="svg-inline--fa fa-magnifying-glass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ fontSize: "18px" }}>
                                    <path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"></path>
                                </svg>
                            </span>
                            <input name="searchBar" placeholder="What are you looking for?" className="pubmed-log-searchBar-input" title="What are you looking for?" value={serachFile} onChange={(e) => setSearchFile(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                        <div style={{ margin: '10px 2px', display: 'flex',justifyContent:'space-evenly'}}>
                            <div>
                                <label>Size:</label>
                                <select className="pub-med-log-drop" value={size} onChange={(e) => { handleSizeChange(e)}}>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                    <option value='100'>100</option>
                                    <option value='200'>200</option>
                                </select></div>
                            <div style={{ display:'flex',alignItems:'center'}}>
                                <span style={{ marginRight: "6px", fontSize: "14px" }}>Selected Year</span>
                                <YearPicker defaultYear={fromYear} handleYear={handleFromYear} />
                                <span style={{ marginRight: "6px", marginLeft: "6px", fontSize: "14px" }}>to</span>
                                <YearPicker defaultYear={toYear} handleYear={handleToYear} />
                            </div>
                        </div>
                    <div style={{ maxHeight: "400px" }}>{(fileLogs.length > 0) &&
                        <PubMedLogsTable
                            data={fileLogs}
                        />}</div>
                </div>
            </div>
        </div>}
    </>)
}
export default PubMedLogs;